export default "__VITE_ASSET__12c208db__"